import React from 'react';
import { Filter, Calendar, MapPin, Building2, Users, DollarSign, Briefcase } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { MultiSelectFilter } from './MultiSelectFilter';

export const ExportFiltersPanel = ({
  exportFilters, filterOptions, loadingOptions,
  onFilterChange, onToggleArrayFilter, onSelectAll, onDeselectAll, onClearFilters,
  filterSummary
}) => (
  <div className="bg-white rounded-xl border border-border p-4 mb-6">
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        <Filter size={18} className="text-[#2E5C8A]" />
        <h3 className="font-semibold text-foreground">Export Filters</h3>
      </div>
      <Button variant="ghost" size="sm" onClick={onClearFilters}>
        Clear All
      </Button>
    </div>

    <div className="bg-slate-50 rounded-lg p-3 mb-4 text-sm text-muted-foreground">
      <span className="font-medium">Current filters:</span> {filterSummary}
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {/* Date Range */}
      <div>
        <Label className="text-sm font-medium mb-1.5 flex items-center gap-1.5">
          <Calendar size={14} />
          Date Range
        </Label>
        <div className="flex gap-2">
          <input
            type="date"
            value={exportFilters.startDate}
            onChange={(e) => onFilterChange('startDate', e.target.value)}
            className="flex-1 px-3 py-2 text-sm border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
            data-testid="export-filter-start-date"
          />
          <input
            type="date"
            value={exportFilters.endDate}
            onChange={(e) => onFilterChange('endDate', e.target.value)}
            className="flex-1 px-3 py-2 text-sm border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
            data-testid="export-filter-end-date"
          />
        </div>
      </div>

      <MultiSelectFilter
        icon={MapPin}
        label="Locations"
        filterKey="locations"
        options={filterOptions.locations}
        selectedValues={exportFilters.locations}
        onToggle={onToggleArrayFilter}
        onSelectAll={onSelectAll}
        onDeselectAll={onDeselectAll}
        loading={loadingOptions}
      />
      <MultiSelectFilter
        icon={Building2}
        label="Departments"
        filterKey="departments"
        options={filterOptions.departments}
        selectedValues={exportFilters.departments}
        onToggle={onToggleArrayFilter}
        onSelectAll={onSelectAll}
        onDeselectAll={onDeselectAll}
        loading={loadingOptions}
      />
      <MultiSelectFilter
        icon={Users}
        label="Supervisors"
        filterKey="supervisors"
        options={filterOptions.supervisors}
        selectedValues={exportFilters.supervisors}
        onToggle={onToggleArrayFilter}
        onSelectAll={onSelectAll}
        onDeselectAll={onDeselectAll}
        loading={loadingOptions}
      />
      <MultiSelectFilter
        icon={DollarSign}
        label="Pay Types"
        filterKey="payTypes"
        options={filterOptions.payTypes}
        selectedValues={exportFilters.payTypes}
        onToggle={onToggleArrayFilter}
        onSelectAll={onSelectAll}
        onDeselectAll={onDeselectAll}
        loading={loadingOptions}
      />

      {/* Employment Status */}
      <div>
        <Label className="text-sm font-medium mb-1.5 flex items-center gap-1.5">
          <Briefcase size={14} />
          Employment Status
        </Label>
        <select
          value={exportFilters.employmentStatus}
          onChange={(e) => onFilterChange('employmentStatus', e.target.value)}
          className="w-full px-3 py-2 text-sm border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          data-testid="export-filter-employment-status"
        >
          <option value="Active">Active Only</option>
          <option value="All">All Employees</option>
          <option value="Inactive">Inactive Only</option>
        </select>
      </div>
    </div>
  </div>
);
